import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch, RootState } from './index';

/**
 * Typed `useDispatch` for the public-website store. Use everywhere
 * instead of plain `useDispatch` so dispatched thunks resolve their
 * return type correctly.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;

/**
 * Typed `useSelector` for the public-website store. Use everywhere
 * instead of plain `useSelector` so selectors get full RootState
 * autocomplete.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
